// removed by extract-text-webpack-plugin
module.exports = {"container":"Survey_container__3ono","progressBar":"Survey_progressBar__Jsdv","navItems":"Survey_navItems__3ti5","navItemSelected":"Survey_navItemSelected__2oLu","cardBody":"Survey_cardBody__2YzF","questionImage":"Survey_questionImage__1Jw7","card":"Survey_card__2PIA","selected":"Survey_selected__37si","buttonBox":"Survey_buttonBox__1WuK","buttonLeft":"Survey_buttonLeft__CduN","buttonRight":"Survey_buttonRight__2y1u","questionTitle":"Survey_questionTitle__2_Ov","summary":"Survey_summary__1q-5","desc":"Survey_desc__3CRE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/Survey.scss
// module id = 583
// module chunks = 0